import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { config, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MasterPageService {
  //TODO
  getSideMenuItems():Observable<any>{
    return of([{link:'#',title:'פתיחת חשבון'},{link:'/update-select',title:'עדכון פרטים אישיים'},
    {link:'#',title:'שכחתי סיסמה'},{link:'#',title:'דיוור והתראות'}]);
  }

  //TOTO get articles
  getArticles(){
     return of([]);
    // return of([{link:'#',title:'כתבה 1',image:'./assets/images/identity-card.png'},
    // {link:'#',title:'כתבה 2',image:'./assets/images/example1.jpg'},
    // {link:'#',title:'כתבה 3',image:'./assets/images/example2.png'},
    // {link:'#',title:'כתבה 4',image:'./assets/images/card-green.svg'}])
  }
}
